// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateProductColor_createButton__3fQT8"};